__turbopack_context__.v({
  "blueskyIcon": "_314Fa_blueskyIcon",
  "copyIcon": "_314Fa_copyIcon",
  "facebookIcon": "_314Fa_facebookIcon",
  "linkIcon": "_314Fa_linkIcon",
  "redditIcon": "_314Fa_redditIcon",
  "shareContainer": "_314Fa_shareContainer",
  "shareNetwork": "_314Fa_shareNetwork",
});
